<template>
  <MarketingPageShell>
    <template #hero>
      <span class="hero-badge">套餐价格</span>
      <h1>{{ pageSeo.h1 }}</h1>
      <p>充值点数存入统一账户，降重、降 AIGC、双降、润色等功能按字数倍率消耗，永久有效。</p>
    </template>

    <div class="rules-row">
      <div v-for="rule in pointsRules" :key="rule.title" class="rule-card">
        <h3>{{ rule.title }}</h3>
        <p>{{ rule.desc }}</p>
        <span>{{ rule.example }}</span>
      </div>
    </div>

    <div class="pricing-grid">
      <div
        v-for="plan in packages"
        :key="plan.productId"
        class="pricing-card"
        :class="{ featured: plan.featured }"
      >
        <div v-if="plan.badge" class="plan-badge">{{ plan.badge }}</div>
        <h3>{{ plan.name }}</h3>
        <div class="price"><span>¥</span>{{ plan.price }}</div>
        <p class="quota">{{ formatQuota(plan.quotaAmount) }} 字</p>
        <p class="per-thousand">{{ plan.perThousand }}</p>
        <p class="desc">{{ plan.description }}</p>
        <router-link to="/workbench" class="btn-primary block">立即购买</router-link>
      </div>
    </div>

    <p class="pricing-tip">登录后在侧边栏点击「去充值」完成购买；套餐以实际支付页为准。</p>
  </MarketingPageShell>
</template>

<script>
import MarketingPageShell from '@/components/portal/MarketingPageShell.vue'
import { RECHARGE_PACKAGES, POINTS_RULES } from '@/constants/rechargePackages'
import { resolvePageSeo } from '@/constants/siteSeo'

export default {
  name: 'PricingView',
  components: { MarketingPageShell },
  computed: {
    pageSeo() {
      return resolvePageSeo('/pricing')
    }
  },
  data() {
    return {
      packages: RECHARGE_PACKAGES,
      pointsRules: POINTS_RULES
    }
  },
  methods: {
    formatQuota(amount) {
      return Number(amount).toLocaleString()
    }
  }
}
</script>

<style scoped>
.hero-badge {
  display: inline-block;
  margin-bottom: 12px;
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--primary-light, #e3f2fd);
  color: var(--primary, #1976d2);
  font-size: 12px;
  font-weight: 600;
}

h1 {
  margin: 0 0 12px;
  font-size: clamp(30px, 4vw, 40px);
  font-weight: 700;
  color: var(--text-primary, #333);
}

.page-hero p {
  margin: 0;
  max-width: 640px;
  font-size: 16px;
  line-height: 1.75;
  color: var(--text-secondary, #666);
}

.rules-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.rule-card {
  padding: 20px 22px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dbeafe;
}

.rule-card h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.rule-card p {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary, #666);
}

.rule-card span {
  font-size: 13px;
  color: var(--primary, #1976d2);
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.pricing-card {
  position: relative;
  padding: 32px 24px;
  border-radius: var(--radius-lg, 16px);
  background: #fff;
  border: 1px solid #e5e7eb;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.pricing-card.featured {
  border-color: var(--primary, #1976d2);
  box-shadow: 0 12px 36px rgba(25, 118, 210, 0.14);
}

.plan-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--primary, #1976d2);
  color: #fff;
  font-size: 11px;
}

.pricing-card h3 {
  margin: 0 0 14px;
  font-size: 20px;
}

.price {
  font-size: 40px;
  font-weight: 700;
  color: var(--primary, #1976d2);
}

.price span {
  font-size: 18px;
  margin-right: 2px;
}

.quota {
  margin: 8px 0 4px;
  color: var(--text-secondary, #666);
}

.per-thousand {
  margin: 0 0 10px;
  font-size: 13px;
  color: var(--text-muted, #999);
}

.desc {
  margin: 0 0 20px;
  min-height: 42px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary, #666);
}

.btn-primary.block {
  width: 100%;
}

.pricing-tip {
  margin: 28px 0 0;
  text-align: center;
  font-size: 14px;
  color: var(--text-muted, #999);
}

@media (max-width: 960px) {
  .rules-row,
  .pricing-grid {
    grid-template-columns: 1fr;
  }
}
</style>
